import { fetchAuthSession } from '@aws-amplify/auth';

import { BACKEND_AGENTS_API } from '../env';

// Administración de Knowledge Bases (pantalla "Agentes → Bases de conocimiento").
// Mismo API Gateway que los agentes (agents-admin). El backend NUNCA devuelve
// identificadores internos de AWS: el front solo maneja el `id` (uuid whisperbi).
const API_BASE = BACKEND_AGENTS_API;
const KB_URL = `${API_BASE}/knowledge-bases`;

async function getAuthHeader() {
  try {
    const idToken = (await fetchAuthSession()).tokens?.idToken?.toString();
    return idToken ? { Authorization: `Bearer ${idToken}` } : {};
  } catch (error) {
    console.error('KnowledgeBaseService.getAuthHeader: unable to fetch session', error);
    return {};
  }
}

async function request(path, init = {}) {
  const authHeader = await getAuthHeader();
  const headers = {
    Accept: 'application/json',
    ...(init.body ? { 'Content-Type': 'application/json' } : {}),
    ...(init.headers || {}),
    ...authHeader
  };
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;

  let response;
  try {
    response = await fetch(url, { ...init, headers, mode: 'cors', cache: 'no-cache' });
  } catch (networkError) {
    throw new Error(`No se pudo contactar el servicio de bases de conocimiento. ${networkError.message}`);
  }

  if (!response.ok) {
    const raw = await response.text().catch(() => '');
    let message = raw || `HTTP ${response.status}`;
    try {
      const parsed = JSON.parse(raw);
      message = parsed.error || parsed.message || message;
    } catch {
      /* texto plano */
    }
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }

  if (response.status === 204) {
    return null;
  }
  const text = await response.text();
  if (!text) {
    return null;
  }
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

const KnowledgeBaseService = {
  async listKnowledgeBases() {
    const data = await request(KB_URL, { method: 'GET' });
    return Array.isArray(data?.items) ? data.items : [];
  },

  async getKnowledgeBase(id) {
    if (!id) {
      throw new Error('id es requerido');
    }
    return request(`${KB_URL}/${encodeURIComponent(id)}`, { method: 'GET' });
  },

  async createKnowledgeBaseFromModel({ semanticModelId, name, description } = {}) {
    if (!semanticModelId) {
      throw new Error('Selecciona un modelo semántico.');
    }
    return request(KB_URL, {
      method: 'POST',
      body: JSON.stringify({
        semantic_model_id: semanticModelId,
        ...(name ? { name } : {}),
        ...(description ? { description } : {})
      })
    });
  },

  async syncKnowledgeBase(id) {
    if (!id) {
      throw new Error('id es requerido');
    }
    return request(`${KB_URL}/${encodeURIComponent(id)}/sync`, { method: 'POST' });
  },

  async deleteKnowledgeBase(id) {
    if (!id) {
      throw new Error('id es requerido');
    }
    return request(`${KB_URL}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
};

export default KnowledgeBaseService;
